module.exports = __webpack_public_path__ + "img/25.51c3db77.png";